import { FC, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router";
import { useRecoilValue } from "recoil";
import { getPharmacyInfoLocal, setCurrentPharmacy } from "../../../api";
import { getImportJobs, getImportJobsCount } from "../../../api/inventoryImport";
import { PharmacyModel } from "../../../models";
import { ImportJob } from "../../../models/import-job";
import { LpFilter, LpWhere } from "../../../models/lp-filter";
import { accountDataState } from "../../../recoil/account";
import { SearchPharmacys } from "../../Pharmacys";

export enum JobStatus {
    onGoing = 'ON_GOING',
    done = 'DONE'
}
const ImportInventoryHistory: FC = () => {
    const accountInfo = useRecoilValue(accountDataState)
    const adminId = useMemo(() => {
        if (accountInfo.loginSession.userLocalType === 'ADMIN')
            return accountInfo.doctor.mId
    }, [accountInfo])
    const history = useHistory()

    const pharmacyInfo = getPharmacyInfoLocal()
    const [selectedPharmacy, setSelectedPharmacy] = useState<PharmacyModel | null>(pharmacyInfo?.pharmacyData ? pharmacyInfo.pharmacyData : null)

    const handleSelectPharmacy = (selectedPharmacy: PharmacyModel) => {
        setSelectedPharmacy(selectedPharmacy);
    }

    const [importJobs, setImportJobs] = useState<ImportJob[]>([]);
    const [jobCount, setJobCount] = useState<number>(0);
    const [offset, setOffset] = useState<number>(0);

    const statusOptions = [
        {
            text: "Tất cả",
            value: "ALL"
        }, {
            text: "Đang xử lý",
            value: "ON_GOING"
        }, {
            text: "Hoàn thành",
            value: "DONE"
        }, {
            text: "Có lỗi",
            value: "HAS_ERROR"
        },
    ]

    const [status, setStatus] = useState<{ text: string, value: string }>(statusOptions[0]);

    const getWhereCondition = (): LpWhere => {
        let where: LpWhere = {
            and: []
        };

        if (selectedPharmacy) {
            where.and!.push({
                mPharmacyId: parseInt(selectedPharmacy.mId)
            })
        }

        if (status.value === 'ON_GOING') {
            where.and!.push({
                mStatus: 'ON_GOING'
            })
        } else if (status.value === 'DONE') {
            where.and!.push({
                mStatus: 'DONE'
            })
            where.and!.push({
                mProgressPercent: 100
            })
        } else if (status.value === 'HAS_ERROR') {
            where.and!.push({
                mStatus: 'DONE'
            })
            where.and!.push({
                mProgressPercent: {
                    lt: 100
                }
            })
        }

        if (!where.and?.length) {
            return {}
        }
        return where;
    }

    const filter: LpFilter = {
        limit: 6,
        offset: 0,
        where: {},
        order: ['mId DESC']
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!adminId) {
                    return;
                }

                setOffset(0)
                let where = getWhereCondition();

                let tempFilter: LpFilter = {
                    ...filter,
                    where
                }

                let results = await Promise.all([
                    getImportJobs(parseInt(adminId), tempFilter),
                    getImportJobsCount(parseInt(adminId), where)
                ])

                setImportJobs(results[0].data);
                setJobCount(results[1].data.count);
            } catch (err) {
                console.error("cannot fetch data: ", err);
            }
        }

        console.log("fetch data");
        fetchData()
    }, [status, selectedPharmacy])

    useEffect(() => {
        if (!adminId
            || !offset) {
            return;
        }

        const fetchData = async () => {
            try {
                let tempFilter: LpFilter = {
                    ...filter,
                    offset: offset,
                    where: getWhereCondition()
                }

                const result = await getImportJobs(parseInt(adminId), tempFilter);
                setImportJobs([...importJobs, ...result.data]);
            } catch (err) {
                console.error("cannot fetch data: ", err);
            }
        }

        fetchData()
    }, [offset])

    const clearSelectedPharmacy = () => {
        setSelectedPharmacy(null);
        setCurrentPharmacy(null);
    }

    const getStatusIcon = (item: ImportJob) => {
        if (item.mStatus === JobStatus.onGoing) {
            return './images/processing.svg';
        } else if (item.mStatus === JobStatus.done) {
            if (item.mTotalLines > (item.mTotalInStock + item.mTotalOutStock)) {
                return './images/report_problem.svg';
            } else {
                return "./images/success.svg";
            }
        }
    }

    const loadMore = () => {
        setOffset(offset + (filter.limit || 10));
    }

    const toDetail = (id: number) => {
        console.log("id: ", id);
        history.push(`/import-job-detail?jobId=${id}`);
    }

    return (
        <div className="management-content">
            <SearchPharmacys handleSelect={handleSelectPharmacy} />

            {
                selectedPharmacy ?
                    <div className="row align-items-center justify-content-between">
                        <div className="col-auto pr-0">
                            <label className="mt-2">NT: {selectedPharmacy.mName}</label>
                        </div>
                        <div className="col-2 text-right">
                            <a href="/#" onClick={(e) => {
                                e.preventDefault();
                                clearSelectedPharmacy();
                            }}>Xoá</a>
                        </div>
                    </div>
                    : ''
            }

            <div className="toolbar row mt-2 mb-4 align-items-center">
                <div className="col-auto pl-0 ml-3">
                    <label className="mt-2 mr-3">Trạng thái (TT)</label>
                    <select className="sort-by" value={status.value} onChange={(e) => {
                        setStatus(statusOptions.find(item => item.value == e.target.value) || statusOptions[0])
                    }}>
                        {
                            statusOptions.map(item => (
                                <option key={item.value} value={item.value}>{item.text}</option>
                            ))
                        }
                    </select>
                </div>
            </div>
            {
                importJobs.length > 0 ?
                    (
                        <div className="row">
                            <div className="table-products">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">NT</th>
                                            <th scope="col" style={{ width: "70px" }}>SP</th>
                                            <th scope="col" style={{ width: "90px" }}>TT</th>
                                            <th scope="col" align="right" style={{ width: "80px" }}>Ngày</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            importJobs.map(item => {
                                                return (
                                                    <tr key={item.mId} onClick={() => { toDetail(item.mId) }}>
                                                        <td>{item.mPharmacyName}</td>
                                                        <td>{item.mTotalLines}</td>
                                                        <td><img src={getStatusIcon(item)} width="18" /></td>
                                                        <td>{new Date(item.mCreated).toLocaleDateString('vi', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {
                                (offset + (filter.limit || 10)) < jobCount ?
                                    <div className="w-100 mt-4 text-center">
                                        <a href="/#" onClick={(e) => {
                                            e.preventDefault();
                                            loadMore()
                                        }}>Xem thêm</a>
                                    </div>
                                    : ''
                            }
                        </div>
                    )
                    : <div></div>
            }

        </div>
    )
}

export default ImportInventoryHistory;